<template>
  <div
    v-if="isLogin || $isLoginFree"
    :class="[
      'switchAccount',
      {
        switchAccountHasData:
          $$(contCourseData.cnt_list).length > 0 ||
          $$(contCourseData.recom_list).length > 0,
      },
    ]"
  >
    <div
      class="switchAccount_change"
      :class="{
        isNotInApp: !$isInApp,
        isLoginFree: $isLoginFree,
      }"
      v-if="
        !$isInApp ||
        ($isInApp &&
          $$(contCourseData.cnt_list).length === 0 &&
          $$(contCourseData.recom_list).length === 0)
      "
    >
      <div class="switchAccount_change_account">
        当前登录网校账号：{{ phone }}
      </div>
      <div
        v-if="!$isLoginFree"
        class="switchAccount_change_switchBtn"
        @click="handleSwitchAccount"
      >
        切换账号
        <img
          class="img_switch"
          src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/switch-icon.png"
        />
      </div>
    </div>
    <div
      class="switchAccount_content"
      v-if="
        $$(contCourseData.cnt_list).length === 0 &&
        $$(contCourseData.recom_list).length === 0
      "
    >
      <img
        class="img_tips"
        src="//static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/error-tips-icon.png"
      />
      <p class="switchAccount_content_oneP">无可报名的课程</p>
      <p class="switchAccount_content_twoP">请检查当前账号是否正确</p>
    </div>
  </div>
  <!-- 如果未登录展示 登录按钮 -->
  <div v-else class="switchAccount">
    <div class="switchAccount_login">
      <p class="switchAccount_login_onwP">还未登录哦</p>
      <p class="switchAccount_login_twoP">请登录之后查看</p>
      <div class="switchAccount_login_btn" @click="handleLogin">登录</div>
    </div>
  </div>
</template>
<script>
import { publicParams } from "@/common/script/log-helper";

export default {
  name: "switchAccount",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: "",
    },
    contCourseData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  mounted() {
    // 无在读课/登错账号页面
    if (this.isLogin) {
      window.__XES_LOG__.loadMsg({
        data_pageid: "1.1.1",
        ...publicParams,
      });
    }
  },
  methods: {
    /**
     * 切换账号的按钮
     */
    handleSwitchAccount() {
      window.__XES_LOG__.clickMsg({
        params: {
          data_clickid: "1.1.1",
          click_name: "切换账号点击",
          ...publicParams,
        },
      });
      // this.$emit("handleLoginPop");
      this.$emit("handleLogout");
    },
    handleLogin() {
      this.$emit("handleLoginPop");
    },
  },
};
</script>

<style lang="less" scoped>
.img {
  &_tips {
    width: 250px;
    height: 186px;
  }
  &_switch {
    width: 16px;
    height: 16px;
  }
}
.switchAccountHasData {
  margin-top: 3px !important;
}
.switchAccount {
  margin-top: 16px;
  // height: 100vh;
  // max-height: 75vh;
  border-radius: 16px;
  background-color: #fff;
  display: flex;
  flex-flow: column;
  &_change {
    height: 36px;
    background: #feebeb;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    color: #f93834;
    font-family: PingFang SC;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    &_account {
      //   width: 230px;
    }
    &_switchBtn {
      //   margin-left: auto;
      //   margin-right: 12px;
      display: flex;
      align-items: center;
    }
    &.isNotInApp {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      box-sizing: border-box;
    }

    &.isLoginFree {
      position: fixed;
      top: 33px;
      z-index: 3;
    }
  }

  &_content {
    margin-top: 103px;
    margin-bottom: 103px;
    display: flex;
    flex-flow: column;
    align-items: center;
    color: #666;
    text-align: center;
    font-family: PingFang SC;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    &_oneP {
      margin-top: 14px;
    }
    &_twoP {
      margin-top: 4px;
    }
  }
  &_login {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    margin-top: 132px;
    &_onwP {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
    &_twoP {
      margin-top: 4px;
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
    &_btn {
      margin-top: 20px;
      width: 126px;
      height: 40px;
      background: #e02727;
      border-radius: 20px;
      color: #ffffff;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 15px;
      text-align: center;
      line-height: 40px;
      // &_font {
      //   height: 21px;
      //   font-size: 15px;
      //   font-family: PingFangSC-Regular, PingFang SC;
      //   font-weight: 400;
      //   color: #ffffff;
      //   line-height: 21px;
      // }
    }
  }
}
</style>
